import React, { useMemo } from 'react'
import { Box, SxProps, Theme, Typography } from '@mui/material'
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI'

interface RolloverTooltipTalbleProps {
  header: string
  rows
  columns
  calculateTotal: boolean
  sx?: SxProps<Theme> | undefined
  dgDimensions: { width: string; height: string }
  dgComponents?
  dgComponentsProps?
}
const RolloverTooltipTable = (props: RolloverTooltipTalbleProps) => {
  const {
    header,
    rows,
    columns,
    calculateTotal,
    sx,
    dgDimensions,
    dgComponents,
    dgComponentsProps
  } = props
  const { width: dgWidth, height: dgHeight } = dgDimensions

  const total = useMemo(() => {
    let tmpTotal = 0
    if (calculateTotal && rows.length > 0) {
      rows.forEach((row: { usage: string }) => {
        tmpTotal += Number(row.usage.slice(0, -2))
      })
    }
    return tmpTotal
  }, [])

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Typography
        sx={{
          fontWeight: '500',
          fontSize: '14px',
          color: '#000',
          mb: '-10px'
          // ml: '-8px'
        }}
      >
        {header}
      </Typography>
      <Box
        sx={{
          height: dgHeight,
          width: dgWidth,
          display: 'flex',
          ml: '8px',
          mt: '10px'
        }}
      >
        <MUIDataGrid
          getRowId={(row) => `${row.CDRID}-index${rows.indexOf(row)}`}
          columns={columns}
          rows={rows}
          // tableHeight='100px'
          rowHeight={30}
          hideFooter
          disableColumnFilter
          disableColumnMenu
          disableSelectionOnClick
          components={!!dgComponents && dgComponents}
          componentsProps={!!dgComponentsProps && dgComponentsProps}
          sx={{
            '& .MuiDataGrid-iconSeparator': {
              visibility: 'hidden'
            },
            '& .MuiDataGrid-footerContainer': {
              border: '0'
            },
            '& .MuiDataGrid-cellContent': {
              fontSize: '14px'
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontSize: '14px',
              fontWeight: '500'
            },
            '& .MuiDataGrid-cell': {
              border: '0px'
            },
            '& .MuiDataGrid-columnHeaders': {
              border: '0px'
            },
            '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
              outline: 'none'
            },
            mx: '-10px'
          }}
        />
      </Box>
      {calculateTotal && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: '-10px',
            mb: '20px',
            mr: '60px'
          }}
        >
          {/* <Typography>Total: {total} GB</Typography> */}
          Total: {total} GB
        </Box>
      )}
    </Box>
  )
}

export default RolloverTooltipTable
